import React from 'react'
import TextField from '@material-ui/core/TextField'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { EditorConvertToHTML } from '../myeditor'
import LiveHelpTwoToneIcon from '@material-ui/icons/LiveHelpTwoTone'
import ArrowDropDownCircle from "@material-ui/icons/ArrowDropDownCircle"
import TitleEditor from './TitleEditor'

export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    upTags,
    attachments,
    children, 
    ...params}){

    const { monitoring, 
        criteriaandinstructions, 
        responsibilities, 
        purposeandintroduction, 
        correctiveactions, 
        verificationandrecordkeeping,
        records,
        text  } = { ... attachments?.attachments?.sop } 
    let masterDoc=sopState.masterDoc?sopState.masterDoc:"";
    let typeOfDoc=sopState.typeOfDoc?sopState.typeOfDoc:"";
    let documentKey=sopState.documentKey?sopState.documentKey:"";
    let name=sopState.name?sopState.name:"";
    return (
        <div>
            <h2>Standard Operation Procedure</h2>
            <form noValidate autoComplete="off">
            <div>
                    <TitleEditor  id="titleEditor"
                     handleFormChange={handleFormChange}
                     setActiveSection={setActiveSection}
                     setUploadOpen={setUploadOpen}
                     sopState={sopState}
                     setSopState={setSopState}
                    />
                </div>
                <div>
                    <TextField id="title" label="" value={sopState.title?sopState.title:masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name} 
                    onChange={(e) => setSopState({...sopState, title:masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name}) } 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof purposeandintroduction !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("purposeandintroduction")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Purpose and introduction</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.purposeandintroduction} 
                                update={ (val) => {
                                    setSopState({...sopState, purposeandintroduction: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof criteriaandinstructions !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("criteriaandinstructions")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Criteria and Instructions</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML
                                html={sopState?.criteriaandinstructions} 
                                update={ (val) => {
                                    setSopState({...sopState, criteriaandinstructions: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div>
                    <TextField id="frequency" label="Frequency" value={sopState.frequency} 
                        onChange={(e) => handleFormChange(e)}
                        style={{width:'80%', marginBottom:20}} multiline rowsMax={4} 
                    />
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof responsibilities !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("responsibilities")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Responsibilities</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.responsibilities} 
                                update={ (val) => {
                                    setSopState({...sopState, responsibilities: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof monitoring !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("monitoring")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Monitoring</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML
                                html={sopState?.monitoring} 
                                update={ (val) => {
                                    setSopState({...sopState, monitoring: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof correctiveactions !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("correctiveactions")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Corrective actions</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.correctiveactions} 
                                update={ (val) => {
                                    setSopState({...sopState, correctiveactions: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof verificationandrecordkeeping !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("verificationandrecordkeeping")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Verification and record keeping</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.verificationandrecordkeeping} 
                                update={ (val) => {
                                    setSopState({...sopState, verificationandrecordkeeping: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content-records"
                            id="panel1a-header-records"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof records !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("records")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Records</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.records} 
                                update={ (val) => {
                                    setSopState({...sopState, records: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                {children}
            </form>
        </div>
    )
}